<template>
  <simple-activity :show-header="false">
    <b-container fluid class="d-flex justify-content-center align-items-center pt-5">
      <b-row class="h-auto h-100-ns justify-content-center align-content-center h-auto-sm pt-2 pb-2"
             style="border: 1px solid #CED5E1; color: #4B5568; border-radius: 10px; width:85% !important">
        <b-col xl="5" sm="12" class="align-content-center">
          <b-row class="justify-content-center align-center w-100">
            <img src="https://silkplm.com/wp-content/uploads/2024/07/Raportowanie.png"
                 alt="Man searching through data - representing of filters"
                 class="filter-representation w-75"/>
          </b-row>
        </b-col>
        <b-col xl="7" sm="12" class="align-content-center justify-center">
          <h3 class="font-weight-bold"> Select filters to generate <br/> {{ report.name }} report</h3>
          <b-row v-for="filter in report.reportFilterSpecs" :key="filter.id">
            <b-col cols="3" sm="12" class="align-content-center">{{ filter.title }}</b-col>
            <b-col cols="9" sm="12" v-if="filter.type === 'DictionaryFilterSpec'">
              <SelectFilterActivityInput :filter="filter" @data-updated="handleDataUpdate"/>
            </b-col>
            <b-col cols="9" sm="12" v-else-if="filter.type === 'DateFilterSpec'">
              <DateFilterActivityInput :filter="filter" @data-updated="handleDataUpdate"/>
            </b-col>
            <b-col cols="9" sm="12" v-else-if="filter.type === 'ApplicationUserFilterSpec'">
              <SelectFilterActivityInput :filter="filter" @data-updated="handleDataUpdate"/>
            </b-col>
            <b-col cols="9" sm="12" v-else-if="filter.type === 'TreeFilterSpec'">
              <SelectFilterActivityInput :filter="filter" @data-updated="handleDataUpdate"/>
            </b-col>
            <b-col cols="9" sm="12" v-else-if="filter.type === 'TreeFilterSpec'">
              <SelectFilterActivityInput :filter="filter" @data-updated="handleDataUpdate"/>
            </b-col>

          </b-row>
          <b-row>
            <b-col cols="9" sm="12" v-if="report.clazzNameForAdditionalVersionOfReport !== 'com.silkplm.engine.reports.XlsReportFromTemplateBase'">
              <CheckboxFilterActivityInput v-model="selectedValuesForCheckbox"
                                           fieldLabel="Generate a version of the report with color versions"
                                           :state="selectedValuesForCheckbox"/>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>

    <template v-slot:footer>
      <b-col>
        <b-button
            :active="false"
            data-test-path="generate-report-button"
            variant="plm-secondary"
            class="px-2 px-sm-2 px-md-4 size-button )"
            :aria-disabled="primaryDisabled"
            :disabled="primaryDisabled"
            :tabindex="0"
            @click.stop="generateReport"
        >
          <slot name="icon">
            <span class="d-none d-md-inline">
              <font-awesome-icon :icon="primaryIcon"/>
            </span>
          </slot>
          <span ref="label">{{ primaryLabel }}</span>
        </b-button>
      </b-col>
    </template>
  </simple-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity";
import XlsReportConfig from "@/server/com/silkplm/engine/reports/XlsReportConfig";
import ReportsManager from "@/ReportsManager";
import DictionaryFilterDataModel from "@/server/com/silkplm/engine/reports/filters/DictionaryFilterDataModel";
import SelectFilterActivityInput from "@/components/plm/reports/SelectFilterActivityInput.vue";
import DateFilterActivityInput from "@/components/plm/reports/DateFilterActivityInput.vue";
import CheckboxFilterActivityInput from "@/components/plm/reports/CheckboxFilterActivityInput.vue";
import DateFilterDataModel from "@/server/com/silkplm/engine/reports/filters/DateFilterDataModel";
import ApplicationUser from "@/server/com/silkplm/model/users/ApplicationUser";
import ApplicationUserFilterDataModel from "@/server/com/silkplm/engine/reports/filters/ApplicationUserFilterDataModel";

export default {
  name: "ReportFiltersParameters",

  components: {SelectFilterActivityInput, SimpleActivity, DateFilterActivityInput, CheckboxFilterActivityInput},

  props: {
    report: {default: null, type: XlsReportConfig},
  },

  async mounted() {
    let i = 0;
    for (let filter of this.report.reportFilterSpecs) {
      filter.id = i++;
    }
  },

  methods: {
    ...Activity.methods,
    getTitle() {
      return this.report.name + " - Filters";
    },
    handleDataUpdate(filterId, result) {
      this.selectedValues[filterId] = result
    },
    async canClose() {
      return true;
    },

    async generateReport() {
      let filters = [];

      for (let filter of this.report.reportFilterSpecs) {
        let value = this.selectedValues[filter.id];
        if (value && value.filterType === "DictionaryFilterSpec") {
          if (value.clazz === ApplicationUser.getRemoteClass()) {
            if (value.filterIds?.length) {
              filters.push(new ApplicationUserFilterDataModel().withListOfUserId(value.filterIds).withClassName(value.clazz).withRole(filter.title));
            } else {
              filters.push(null);
            }
          } else {
            if (value.filterIds?.length) {
              filters.push(new DictionaryFilterDataModel().withListOfInstanceId(value.filterIds).withClassName(value.clazz));
            } else {
              filters.push(null);
            }
          }
        } else if (value && value.filterType === "DateFilterSpec") {
          let dateFilterDataModel = new DateFilterDataModel();
          dateFilterDataModel.withStartDateExpectedValue(value.startDateExpectedValue);
          dateFilterDataModel.withEndDateExpectedValue(value.endDateExpectedValue);
          filters.push(dateFilterDataModel);
        } else {
          filters.push(null);
        }
      }

      if (this.selectedValuesForCheckbox){
        await ReportsManager.executeReport(this.report.clazzNameForAdditionalVersionOfReport, filters);
      } else {
        await ReportsManager.executeReport(this.report.reportClassName, filters);
      }
    },
  },

  data() {
    return {
      selectedValues: {},
      filteredClass: {},
      selectedValuesForCheckbox: false,
      primaryLabel: $tr("Generate-button", "Generate"),
      primaryIcon: "fa-solid fa-rotate",
      primaryDisabled: false,
    }
  },
  computed: {}
}
</script>

<style scoped>
@media screen and (max-width: 900px) {
  .filter-representation {
    width: 70vw;
    margin-right: 20px;
  }
}

@media screen and (min-width: 900px) {
  .filter-representation {
    width: 35vw;
    margin-right: 20px;
  }
}

</style>
